import React, { useState } from "react";

export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape' && isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="bg-white w-full font-elegant sticky top-0 z-50 shadow-md" role="navigation" aria-label="Menu principale">
      {/* Logo e Hamburger Icon */}
      <div className="flex items-center justify-between px-4 py-3 md:py-4 lg:flex-col lg:items-center max-w-7xl mx-auto">
        {/* Logo */}
        <a
          href="/"
          className="lg:mb-4 focus:outline-none focus:ring-4 focus:ring-green-800 rounded transition-transform hover:scale-105"
          aria-label="Vai alla home page"
        >
          <img
            className="h-[60px] md:h-[80px] lg:h-[100px] w-auto"
            src="/img/Logo2.png"
            alt="Logo Orologeria Strippoli"
          />
        </a>
        {/* Burger Icon (visible on mobile) */}
        <button
          className="text-green-800 text-2xl lg:hidden min-h-[44px] min-w-[44px] flex items-center justify-center focus:outline-none focus:ring-4 focus:ring-green-800 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          onKeyDown={handleKeyDown}
          aria-label="Menu di navigazione"
          aria-expanded={isMenuOpen}
          aria-controls="main-menu"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {/* Menu Links */}
      <div
        id="main-menu"
        className={`${
          isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0 lg:max-h-screen lg:opacity-100"
        } overflow-hidden transition-all duration-300 ease-in-out lg:flex lg:flex-col lg:items-center bg-white lg:bg-transparent`}
        aria-hidden={!isMenuOpen && "true"}
      >
        <div className="flex flex-col lg:flex-row justify-center items-stretch lg:items-center gap-0 lg:gap-6 xl:gap-8 py-2 lg:py-4 border-t lg:border-t-0 border-gray-100">
          <a
            href="/gioielleria"
            className="text-base md:text-lg lg:text-base xl:text-lg font-medium text-gray-700 hover:text-green-800 hover:bg-gray-50 lg:hover:bg-transparent font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 py-3 px-6 lg:px-4 min-h-[44px] flex items-center transition-all duration-200 border-l-4 border-transparent hover:border-green-800 lg:border-l-0 lg:border-b-2"
            onClick={() => setIsMenuOpen(false)}
          >
            GIOIELLERIA
          </a>
          <a
            href="/orologeria"
            className="text-base md:text-lg lg:text-base xl:text-lg font-medium text-gray-700 hover:text-green-800 hover:bg-gray-50 lg:hover:bg-transparent font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 py-3 px-6 lg:px-4 min-h-[44px] flex items-center transition-all duration-200 border-l-4 border-transparent hover:border-green-800 lg:border-l-0 lg:border-b-2"
            onClick={() => setIsMenuOpen(false)}
          >
            OROLOGERIA
          </a>
          <a
            href="/chi-siamo"
            className="text-base md:text-lg lg:text-base xl:text-lg font-medium text-gray-700 hover:text-green-800 hover:bg-gray-50 lg:hover:bg-transparent font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 py-3 px-6 lg:px-4 min-h-[44px] flex items-center transition-all duration-200 border-l-4 border-transparent hover:border-green-800 lg:border-l-0 lg:border-b-2"
            onClick={() => setIsMenuOpen(false)}
          >
            CHI SIAMO
          </a>
          <a
            href="/marchi"
            className="text-base md:text-lg lg:text-base xl:text-lg font-medium text-gray-700 hover:text-green-800 hover:bg-gray-50 lg:hover:bg-transparent font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 py-3 px-6 lg:px-4 min-h-[44px] flex items-center transition-all duration-200 border-l-4 border-transparent hover:border-green-800 lg:border-l-0 lg:border-b-2"
            onClick={() => setIsMenuOpen(false)}
          >
            MARCHI
          </a>
          <a
            href="/contattaci"
            className="text-base md:text-lg lg:text-base xl:text-lg font-medium text-white bg-green-800 hover:bg-green-900 lg:bg-green-800 lg:text-white font-elegant focus:outline-none focus:ring-2 focus:ring-green-800 py-3 px-6 lg:px-4 lg:rounded-lg min-h-[44px] flex items-center justify-center transition-all duration-200 lg:shadow-md hover:shadow-lg"
            onClick={() => setIsMenuOpen(false)}
          >
            CONTATTACI
          </a>
        </div>
      </div>
    </nav>
  );
};
